import { render, staticRenderFns } from "./edit-tenant-personalization.vue?vue&type=template&id=6c6be9ea&scoped=true&"
import script from "./edit-tenant-personalization.vue?vue&type=script&lang=js&"
export * from "./edit-tenant-personalization.vue?vue&type=script&lang=js&"
import style0 from "./edit-tenant-personalization.vue?vue&type=style&index=0&id=6c6be9ea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6be9ea",
  null
  
)

export default component.exports